
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/[cName]/collections/[slug]",
      function () {
        return require("private-next-pages/stores/[cName]/collections/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/[cName]/collections/[slug]"])
      });
    }
  